module.exports = __webpack_public_path__ + "img/Edit.149c3412.svg";